import React from 'react';
import { ToggleButton, ToggleButtonGroup, Typography, Box } from '@mui/material';
import { loadBillingFilters, saveBillingFilters } from 'Includes/billingFilterStorage';

export const ORDERS_SOURCE_LEGACY = 'orders';
export const ORDERS_SOURCE_V2 = 'orders_v2';

export const loadOrdersSource = () => {
  const stored = loadBillingFilters().orderSource;
  return stored === ORDERS_SOURCE_V2 ? ORDERS_SOURCE_V2 : ORDERS_SOURCE_LEGACY;
};

function OrdersSourceToggle({ value, onChange }) {
  const handleChange = (_event, next) => {
    if (!next) return;
    saveBillingFilters({ orderSource: next });
    if (onChange) onChange(next);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
        Order source
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={handleChange}
        sx={{
          bgcolor: '#f8fafc',
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontWeight: 700,
            px: 1.75,
            py: 0.5,
          },
        }}
      >
        <ToggleButton value={ORDERS_SOURCE_LEGACY}>Orders</ToggleButton>
        <ToggleButton value={ORDERS_SOURCE_V2}>Orders V2</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default OrdersSourceToggle;
